import { render } from "./RegistrationConfirmView.vue?vue&type=template&id=d6baca88"
import script from "./RegistrationConfirmView.vue?vue&type=script&lang=js"
export * from "./RegistrationConfirmView.vue?vue&type=script&lang=js"

import exportComponent from "d:\\projekty\\www\\cdif3com\\rental\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__